import React from 'react';
import PropTypes from 'prop-types';
import { useStaticQuery, graphql } from 'gatsby';

const SEO = ({ title, description, keywords, image, noIndex }) => {
	const metaData = useStaticQuery(graphql`
		query {
			site {
				siteMetadata {
					title
					description
					author
				}
			}
		}
	`).site.siteMetadata;

	return (
		<>
			<title>{title ? title + ' | ' : metaData?.title ? metaData.title + ' | ' : ''}Custom Window Systems</title>
			<meta
				name='description'
				content={description || metaData.description}
			/>
			<meta
				name='keywords'
				content={keywords}
			/>
			{image && (
				<meta
					name='image'
					content={image}
				/>
			)}
			<meta
				property='og:title'
				content={title || metaData.title}
			/>
			<meta
				property='og:description'
				content={description || metaData.description}
			/>
			<meta
				property='og:type'
				content='website'
			/>
			{image && (
				<meta
					property='og:image'
					content={image}
				/>
			)}
			<meta
				name='twitter:card'
				content='summary_large_image'
			/>
			<meta
				name='twitter:title'
				content={title || metaData.title}
			/>
			<meta
				name='twitter:description'
				content={description || metaData.description}
			/>
			{image && (
				<meta
					name='twitter:image'
					content={image}
				/>
			)}
			{typeof window !== 'undefined' && (
				<meta
					property='og:url'
					content={window.location.origin + window.location.pathname}
				/>
			)}
			{typeof window !== 'undefined' && (
				<link
					rel='canonical'
					href={window.location.origin + window.location.pathname}
				/>
			)}
			{noIndex && (
				<meta
					name='robots'
					content='noindex'
				/>
			)}
		</>
	);
};

SEO.propTypes = {
	title: PropTypes.string,
	description: PropTypes.string,
	keywords: PropTypes.string,
	image: PropTypes.string,
	noIndex: PropTypes.bool,
};

export default SEO;
